import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import FaqInner from '../Components/Faq/FaqInner'
import ElementSection from '../Components/Elements/ElementSection'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import { usePageBanner } from '../hooks/usePageBanner'

function Faq() {
    const { title, bgImage } = usePageBanner({
        pageSlug: 'faq',
        fallbackTitle: 'FAQs',
    })

    return (
        <>
            <HeaderOne />
            <Breadcrumb title={title} bgImage={bgImage} />
            <FaqInner />
            <ElementSection />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Faq
